/**
 * Given information about a view, constructs the appropriate share link.
 * @param {object} options - An object representing view state.
 * @param {string} options.dataView - Required. The data view to use.
 * @param {string} options.indicatorSubView - Optional. Sub-view to use (e.g., state).
 * @param {string} options.indicatorView - Optional. View to use (e.g., map).
 * @param {string} options.slug - Required. The indicator slug to use.
 * @param {number} options.timeframe - Optional. Timeframe value.
 * @param {array} options.geos - Optional. A list of FIPS codes and/or state IDs.
 * @returns {string} - The compiled share URL.
 */
export default function shareLink({
  dataView,
  geos = [],
  indicatorSubView = '',
  indicatorView = '',
  slug,
  timeframe = -1,
}) {
  // Construct the indicator view conditionally.
  const viewSegment = indicatorView ? `/${indicatorView}` : '';

  // Construct the indicator subview conditionally.
  const subViewSegment = viewSegment && indicatorSubView ?
    `/${indicatorSubView}` :
    '';

  // Construct the timeframe segment conditionally.
  const timeSegment = -1 !== timeframe ? `/${timeframe}` : '';

  // Construct the geos segment conditionally.
  const geosQuery = geos.length ? `?geos=${geos.join(',')}` : '';

  // Compile the URL.
  return `https://www.prb.org/${dataView}/indicator/${slug}\
${viewSegment}${subViewSegment}${timeSegment}${geosQuery}`;
}



// WEBPACK FOOTER //
// ./app/services/shareLink.js